<template>
  <div class="strap-collage" v-if="strap.url && dial.cadran.url">
    <lazy-image
      :class-name="
        dial.soldat
          ? 'product-header-item-image soldat'
          : 'product-header-item-image'
      "
      ref="picture"
      :item="strap"
    />
    <lazy-image
      :item="dial.cadran"
      :draggable="'false'"
      :class-name="
        dial.soldat
          ? 'product-header-item-image over-image soldat'
          : 'product-header-item-image over-image'
      "
      ref="dialPicture"
    />
  </div>
</template>

<script>
import { ReadyHook } from 'vue-asyncready'
import LazyImage from './utils/LazyImage'

export default {
  props: ['strap', 'dial'],
  name: 'StrapUnderDial',
  mixins: [ReadyHook],
  components: {
    LazyImage
  },
  created() {},
  watch: {},
  data() {
    return {
      autoReady: false
    }
  },
  computed: {},
  methods: {}
}
</script>

<style lang="scss" scoped>
@import '~theme/css/core';

.strap-collage .product-header-item-image {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  /deep/ img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  &.over-image {
    z-index: 2;
  }

  &.soldat {
    max-height: 72vh;
    width: 70%;

    @media (min-width: 321px) {
      width: 80%;
    }
    @include bp(sm) {
      width: 65%;
    }
    @include bp(md) {
      width: 48%;
    }
    @include bp(lg) {
      height: 55rem;
      width: 70%;
    }
    /deep/ img {
      object-fit: contain;
    }
  }
}
</style>
